import { Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styles from './organization.module.scss';
import { OrganizationSmallForm } from '@modules/profile/organization/organization-small-form/ui/organization-small-form';

export const Organization = () => {
  const { Text } = Typography;
  const { t } = useTranslation('translation', { keyPrefix: 'profile.organization' });

  return (
    <Flex className={styles.root} flex={1} vertical>
      <Flex className={styles.container} vertical>
        <Text className={styles.title}>{t('title')}</Text>

        <OrganizationSmallForm />
      </Flex>
    </Flex>
  );
};
